import _$ from "1dr-utils/helpers/docReady";
import qsa from "1dr-utils/helpers/elsForEach";
import summary from "@/js/parts/checkout/refreshSummary";
import cartStates from "@/js/parts/checkout/cartStates";
import { InputErrors } from "@/js/libs/form-errors";

export default function (id) {
  _$(function () {
    const form = document.getElementById(id);

    if (!form) {
      return;
    }

    const tandc = form.querySelector("#payment-tandc");
    let tandcErrors;

    if (tandc) {
      tandcErrors = new InputErrors(tandc);

      tandc.addEventListener("change", () => {
        tandcErrors.validate(true);
      });

      qsa(form.querySelectorAll('[type="submit"]'), (btn) => {
        btn.addEventListener("click", () => {
          tandcErrors.validate(true);
        });
      });
    }

    form.addEventListener("submit", (e) => {
      cartStates.loading();
      summary.loading();

      var submits = e.target.querySelectorAll('[type="submit"]');

      e.target.setAttribute("disabled", "true");
      e.target.setAttribute("data-state", "loading");

      qsa(submits, (submit) => {
        submit.setAttribute("disabled", "true");
        submit.setAttribute("data-state", "loading");
      });
    });
  });
}
